/**
 * Will return true if number consists of numbers, dashes
 * and is in the form (###)-###-#### or #-(###)-###-####
 */
export const validateNumber = number => {
  const regExp = /(^\(\d{3}\)-\d{3}-\d{4}$)|(^\d-\(\d{3}\)-\d{3}-\d{4}$)/;
  return regExp.test(number);
};

export const validateEmail = () => {
  return true;
};
